import { toBoolOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IAssessOrganDiseaseFormValues,
    IAssessOrganDiseaseModel,
    IAssessOrganDiseaseSubmitResult,
} from '@/types/screening/assess-organ-disease';

const ASSESS_ORGAN_DISEASE_ENDPOINT = '/api/register/assess-organ-disease';

const defaultAssessOrganDiseaseModel: IAssessOrganDiseaseModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessOrganDisease,

    hasHadOrganDisease: null,
};

export const useAssessOrganDisease = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_ORGAN_DISEASE_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessOrganDiseaseModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<
        IAssessOrganDiseaseFormValues,
        DashRegistrationStep,
        IAssessOrganDiseaseSubmitResult
    >(
        url,
        (values) => ({
            hasHadOrganDisease: toBoolOrNull(values.hasHadOrganDisease),
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
